
import React from 'react'
import loadable from '@loadable/component'
import { Skeleton } from '@salesforce/retail-react-app/app/components/shared/ui'
import { routes as _routes } from '@salesforce/retail-react-app/app/routes'
const fallback = <Skeleton height="75vh" width="100%" />
const LeftNavLayout = loadable(() => import('./components/left-nav-layout'), { fallback })
const LeftNav = loadable(() => import('./components/left-nav'), { fallback })

const CustomerServiceContent = loadable(() => import('./pages/content/customer-service/help'), { fallback })
const FaqsContent = loadable(() => import('./pages/content/customer-service/faqs'), { fallback })

const CustomerService = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <CustomerServiceContent />
    </LeftNavLayout>
)

const Faqs = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <FaqsContent />
    </LeftNavLayout>
)

const CustomerServiceRoutes = [
    {
        path: '/help/',
        component: CustomerService,
        exact: true
    },
    {
        path: '/content/faqs.html',
        component: Faqs,
        exact: true
    },
]

export default CustomerServiceRoutes